import type { ReactNode } from 'react';

export type PillKind =
  | 'paid'
  | 'refunded'
  | 'partial'
  | 'declined'
  | 'live'
  | 'upcoming'
  | 'ended'
  | 'draft';

export interface PillProps {
  kind?: PillKind;
  children: ReactNode;
}

export function Pill({ children, kind = 'paid' }: PillProps) {
  return <span className={`pill pill-${kind}`}>{children}</span>;
}
